import React, { useEffect, useState } from "react";
import {
  dateTimeFieldToDate,
  getDateToday,
} from "../../../Utils/externalFunctions";
import useAxios from "../../../Utils/useAxios";
import DataTable from "react-data-table-component";
import { STATUS_DATA_TYPE } from "../../../Constant/StatusData";
import SubHeaderComponent from "../../DataTableComponents/commonSubHeaderComponent";
import ConfirmRemovalModal from "../components/ConfirmRemovalModal";
import EditStatusDaftarStatus from "../components/EditStatusDaftarAkun";
import { customStyles } from "../../DataTableComponents/CustomStyle";
import { filterSearch } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import CreateButton from "../../../CommonElements/Button/CreateButton";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import DaftarAkunColumns from "../constants/DaftarAkunColumns";
import getUnitKerja from "../services/getUnitKerja";
import getRencImpAkun from "../services/getRencImp";
import getKegiatan from "../../Dashboard/services/getKeigatan";
import getDaftarAkun from "../../Dashboard/services/getDaftarAkun";
import ModalDaftarAkun from "../components/ModalDaftarAkun";

const DaftarAkunContain = () => {
  const axiosInstance = useAxios();
  const [rencImpList, setRencImpList] = useState([]);
  const [unitKerja, setUnitKerja] = useState([]);
  const [kegiatan, setKegiatan] = useState([]);
  const [daftarAkun, setDaftarAkun] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedStatusAkun, setSelectedStatusAkun] = useState("0");
  const [selectedFilterUnitKerja, setSelectedFilterUnitKerja] = useState("");
  const [selectedFilterTanggal, setSelectedFilterTanggal] = useState("");
  const [selectedAkun, setSelectedAkun] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editStatusModalOpen, setEditStatusModalOpen] = useState(false);
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);
  const toggleEditStatusModal = () =>
    setEditStatusModalOpen(!editStatusModalOpen);

  const [modalCreateAkunOpen, setModalCreateAkunOpen] = useState(false);
  const toggleModalCreateAkun = () =>
    setModalCreateAkunOpen(!modalCreateAkunOpen);

  const [pending, setPending] = useState(true);

  const { themeContext } = useThemeContext();

  let isMounted = true;
  useEffect(() => {
    refreshUnitKerja();
    refreshRencImp();
    refreshKegiatan();
    refreshDaftarAkun();

    return () => {
      isMounted = false;
    };
  }, []);

  const refreshUnitKerja = async () => {
    getUnitKerja(axiosInstance).then((response) => {
      setUnitKerja(response.data);
    });
  };

  const refreshRencImp = async () => {
    getRencImpAkun(axiosInstance).then((res) => {
      setRencImpList(res.data);
      setPending(false);
    });
  };

  const refreshKegiatan = async () => {
    getKegiatan(axiosInstance).then((response) => {
      setKegiatan(response.data);
    });
  };

  const refreshDaftarAkun = async () => {
    getDaftarAkun(axiosInstance).then((response) => {
      setDaftarAkun(response.data);
    });
  };

  const handleEditStatus = (akun) => {
    setSelectedAkun(akun);
    toggleEditStatusModal();
  };

  const handleDeleteAkun = (akun) => {
    setSelectedAkun(akun);
    toggleDeleteModal();
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterAkunItems = (items) => {
    const searchCategories = [
      "pk",
      "nm_org",
      "nm_keg",
      "kd_keg",
      "nm_akun",
      "kd_akun",
    ];
    const filteredItems = items
      .filter(filterSearch(searchCategories, filterText))
      .filter(filterStatus)
      .filter(filterSearch(["nm_org"], selectedFilterUnitKerja))
      .filter(filterTanggal);
    return filteredItems;
  };

  const filterStatus = (item) => {
    return selectedStatusAkun === "0"
      ? item
      : item.status_akun && item.status_akun === selectedStatusAkun;
  };
  const filterTanggal = (item) => {
    return selectedFilterTanggal === ""
      ? item
      : item.untuk_tanggal &&
          item.untuk_tanggal <= selectedFilterTanggal &&
          item.batas_akhir &&
          item.batas_akhir >= selectedFilterTanggal;
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        dateTimeFieldToDate(row.date_created) === getDateToday("original"),
      style: (row) => ({
        backgroundColor: row.date_created ? "pink" : "red",
      }),
    },
  ];

  return (
    <FeatureContainer
      title={"Daftar Akun"}
      createButton={
        FEATURE_FUNCTION_SELECTION.AkunBaru.Create && (
          <CreateButton toggle={toggleModalCreateAkun}>
            Buat Akun Baru
          </CreateButton>
        )
      }
    >
      <DataTable
        columns={DaftarAkunColumns(
          themeContext,
          handleEditStatus,
          handleDeleteAkun
        )}
        data={filterAkunItems(rencImpList)}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        selectableRowsHighlight
        highlightOnHover
        subHeader
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        subHeaderComponent={
          <SubHeaderComponent
            filterText={filterText}
            setFilterText={setFilterText}
            handleClear={handleClear}
            setSelectedStatus={setSelectedStatusAkun}
            setSelectedFilterUnitKerja={setSelectedFilterUnitKerja}
            setSelectedFilterTanggal={setSelectedFilterTanggal}
            unitKerja={unitKerja}
            statusDataType={STATUS_DATA_TYPE.AkunBaru}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={themeContext}
      />
      <ModalDaftarAkun
        getRencImp={refreshRencImp}
        unitKerja={unitKerja}
        kegiatan={kegiatan}
        daftarAkun={daftarAkun}
        modal={modalCreateAkunOpen}
        toggle={toggleModalCreateAkun}
      />
      {selectedAkun && (
        <EditStatusDaftarStatus
          editStatusModalOpen={editStatusModalOpen}
          toggleEditStatusModal={toggleEditStatusModal}
          selectedAkun={selectedAkun}
          getRencImp={refreshRencImp}
          axiosInstance={axiosInstance}
        />
      )}
      {selectedAkun && (
        <ConfirmRemovalModal
          deleteModalOpen={deleteModalOpen}
          toggleDeleteModal={toggleDeleteModal}
          selectedAkun={selectedAkun}
          getRencImp={refreshRencImp}
          axiosInstance={axiosInstance}
        />
      )}
    </FeatureContainer>
  );
};

export default DaftarAkunContain;
